import {CanActivateFn} from '@angular/router';
import {inject} from '@angular/core';
import {catchError, map, of} from 'rxjs';
import {SettingsMenuItemType} from '../types/generated/settingsMenuItemType';
import {ModuleConfigurationService} from '../services/module-configuration.service';
import {RouterService} from '../services/router.service';
import {CapabilitiesService} from '../services/capabilities.service';
import {TokenService} from '../services/token.service';

export const moduleRoutingAvailabilityGuard: CanActivateFn = (route, state) => {
  const requiredMenuType = route.data?.['requiredMenuType'] as SettingsMenuItemType | undefined;

  if (!requiredMenuType) {
    return true;
  }

  const moduleConfigurationService = inject(ModuleConfigurationService);
  const routerService = inject(RouterService);
  const capabilitiesService = inject(CapabilitiesService);
  const tokenService = inject(TokenService);

  const resolveRoutingAvailability = (): boolean => {
    if (!moduleConfigurationService.isLegacyModuleType(requiredMenuType)) {
      return true;
    }

    const fallbackRoute = moduleConfigurationService.getLegacyRouteForTarget(state.url)
      ?? moduleConfigurationService.getRouteForModuleType(requiredMenuType)
      ?? '/home';

    routerService.navigateTo(fallbackRoute);
    return false;
  };

  if (!tokenService.hasToken() || capabilitiesService.capabilitiesLoaded()) {
    return resolveRoutingAvailability();
  }

  return capabilitiesService.fetchUserCapabilities().pipe(
    map((capabilities) => {
      capabilitiesService.applyCapabilities(capabilities);
      return resolveRoutingAvailability();
    }),
    catchError(() => of(resolveRoutingAvailability()))
  );
};
